//
export var EHoldingType;
(function (EHoldingType) {
    EHoldingType["RTGS"] = "RTGS";
    EHoldingType["Cheque"] = "Cheque";
})(EHoldingType || (EHoldingType = {}));
